import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import { DeclineCaseForm } from '@lp/features/forms/DeclineCaseForm';
import { getCancellationReasons, getSpecifications } from '../utils';
import { SelectItemType } from '@/types';
import { CaseStatus, DeclineCaseParams } from '@/api/apis/case';

export const DeclineServiceBody = ({ status }: { status: CaseStatus }) => {
  const { control, setValue } = useFormContext<DeclineCaseParams>();
  const declineReason = useWatch({ control, name: 'declineReason' });
  const dispositionReason = useWatch({ control, name: 'dispositionReason' });
  const dispositionSpecification = useWatch({ control, name: 'dispositionSpecification' });

  const dispositionReasons = getCancellationReasons(declineReason);
  const dispositionSpecifications = getSpecifications(dispositionReason);

  useEffect(() => {
    const setValueAsNeeded = (option: string, options: SelectItemType[], key: keyof DeclineCaseParams) => {
      const valueInOptions = options.find((o) => o.value === option);
      if (!valueInOptions) {
        setValue(key, options[0]?.value || '');
      }
    };
    setValueAsNeeded(dispositionReason, dispositionReasons, 'dispositionReason');
    setValueAsNeeded(dispositionSpecification, dispositionSpecifications, 'dispositionSpecification');
  }, [dispositionReasons, dispositionReason, dispositionSpecifications, dispositionSpecification, setValue]);

  return (
    <DeclineCaseForm
      status={status}
      dispositionReasons={dispositionReasons}
      dispositionSpecifications={dispositionSpecifications}
    />
  );
};
